<template>
  <div
    class="container-fluid min-vh-100 d-flex align-items-center justify-content-center bg-gradient"
  >
    <div
      class="card shadow-lg border-0 rounded-lg"
      style="max-width: 480px; width: 100%"
    >
      <div class="card-header bg-primary text-white text-center py-4">
        <h4 class="mb-0">修改访问密码</h4>
      </div>

      <div class="card-body p-4 p-lg-5">
        <form @submit.prevent="submit">
          <!-- 原密码 -->
          <div class="mb-3">
            <label for="oldPassword" class="form-label">原密码</label>
            <input
              type="password"
              class="form-control"
              :class="{ 'is-invalid': errors.oldPassword }"
              id="oldPassword"
              v-model="form.oldPassword"
              placeholder="请输入当前访问密码"
              required
              autocomplete="off"
            />
            <div v-if="errors.oldPassword" class="invalid-feedback">
              {{ errors.oldPassword }}
            </div>
          </div>

          <!-- 新密码 -->
          <div class="mb-3">
            <label for="newPassword" class="form-label">新密码</label>
            <input
              type="password"
              class="form-control"
              :class="{ 'is-invalid': errors.newPassword }"
              id="newPassword"
              v-model="form.newPassword"
              placeholder="6-20位，支持字母、数字和常见符号"
              required
            />
            <div v-if="errors.newPassword" class="invalid-feedback">
              {{ errors.newPassword }}
            </div>
          </div>

          <!-- 确认新密码 -->
          <div class="mb-4">
            <label for="confirmPassword" class="form-label">确认新密码</label>
            <input
              type="password"
              class="form-control"
              :class="{ 'is-invalid': errors.confirmPassword }"
              id="confirmPassword"
              v-model="form.confirmPassword"
              placeholder="请再次输入新密码"
              required
              @keyup.enter="submit"
            />
            <div v-if="errors.confirmPassword" class="invalid-feedback">
              {{ errors.confirmPassword }}
            </div>
          </div>

          <!-- 提示信息 -->
          <div
            v-if="message"
            class="alert"
            :class="msgType === 'success' ? 'alert-success' : 'alert-danger'"
            role="alert"
          >
            {{ message }}
          </div>

          <!-- 按钮 -->
          <div class="d-grid gap-2 d-md-flex justify-content-md-end">
            <button
              type="button"
              class="btn btn-secondary me-md-2"
              @click="reset"
              :disabled="loading"
            >
              重置
            </button>
            <button type="submit" class="btn btn-primary" :disabled="loading">
              <span
                v-if="loading"
                class="spinner-border spinner-border-sm me-2"
                role="status"
              ></span>
              {{ loading ? "提交中..." : "确认修改" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "UpdatePassword",
  data() {
    return {
      form: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      errors: {},
      message: "",
      msgType: "", // 'success' 或 'error'
      loading: false,
    };
  },
  methods: {
    validate() {
      this.errors = {};

      if (!this.form.oldPassword) {
        this.errors.oldPassword = "请输入原密码";
      }

      if (!this.form.newPassword) {
        this.errors.newPassword = "请输入新密码";
      } else if (
        this.form.newPassword.length < 6 ||
        this.form.newPassword.length > 20
      ) {
        this.errors.newPassword = "新密码长度必须为6-20位";
      }

      if (!this.form.confirmPassword) {
        this.errors.confirmPassword = "请确认新密码";
      } else if (this.form.confirmPassword !== this.form.newPassword) {
        this.errors.confirmPassword = "两次输入的密码不一致";
      }

      return Object.keys(this.errors).length === 0;
    },

    async submit() {
      if (!this.validate()) return;

      this.loading = true;
      this.message = "";
      this.msgType = "";

      // 第一步：校验原密码是否正确
      await this.$axios({
        method: "post",
        url: "/api/gate/updatePwd", // 改成你的实际接口
        data: {
          before: this.form.oldPassword,
          new: this.form.newPassword,
        },
      })
        .then((resp) => {
          if (resp.data.code === 200) {
            this.msgType = "success";
            this.message =
              "密码修改成功！下次访问请使用新密码。页面即将跳转.....";
            sessionStorage.removeItem("gate_ok");
            // 3秒后自动返回首页
            setTimeout(() => {
              this.$router.push("/x9k2p-gate-7m4q");
            }, 3000);
          } else {
            this.message = resp.data.msg;
          }
        })
        .catch((err) => {
          this.msgType = "error";
          this.message = err.message || "修改失败，请重试";
        })
        .finally(() => {
          this.loading = false;
        });
    },

    reset() {
      this.form = { oldPassword: "", newPassword: "", confirmPassword: "" };
      this.errors = {};
      this.message = "";
      this.msgType = "";
    },
  },

  created() {
    // 未通过主密码验证的，直接踢回 gate 页面
    // if (sessionStorage.getItem("gate_ok") !== "1") {
    //   this.$router.push("/gate");
    // }
  },
};
</script>
  
  <style scoped>
.bg-gradient {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.card {
  background: rgba(255, 255, 255, 0.95);
}

.card-header {
  border-radius: calc(0.5rem - 1px) calc(0.5rem - 1px) 0 0 !important;
}

.form-control:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}
</style>